module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 23
// module chunks = 0